<!-- Показывает даты создания и обновления записи в обычном или компактном виде. -->
<template>
  <div
    v-if="createdAt || updatedAt"
    class="meta-time-box"
    :class="{ 'meta-time-box--compact': compact }"
  >
    <span class="create-time" v-if="createdAt">Создано: {{ formatDateAndTime(createdAt) }}</span>
    <span class="update-time" v-if="updatedAt">Обновлено: {{ formatDateAndTime(updatedAt) }}</span>
  </div>
</template>

<script>
import { formatDateAndTime, formatDateAndTimeLocal } from "@/utils/dateUtils";

export default {
  name: "MetaTime",
  props: {
    localTime: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
    createdAt: { type: String, required: false },
    updatedAt: { type: String, required: false },
  },
  data() {
    return {};
  },
  methods: {
    formatDateAndTime(value) {
      return this.localTime ? formatDateAndTimeLocal(value) : formatDateAndTime(value);
    },
  },
};
</script>

<style scoped>
.meta-time-box {
  display: flex;
  flex-direction: column;
}

.create-time,
.update-time {
  color: #8b91a3;
  font-size: 12px;
  font-style: normal;
  line-height: 16px;
}

.update-time {
  margin-top: 5px;
}

.meta-time-box--compact {
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px 14px;
}

.meta-time-box--compact .create-time,
.meta-time-box--compact .update-time {
  margin-top: 0;
}
</style>
